import React from 'react';
import { observer } from 'mobx-react';
import BillReminderDialog from './BillReminderDialog';
import BillReminderService from '../../services/BillReminderService';

class BillReminderDialogContainer extends React.Component {
  constructor(props) {
    super(props);
    this.billReminderService = new BillReminderService();
  }

  componentDidMount() {
    this.billReminderService.load();
  }

  render() {
    return <BillReminderDialog isOpen={this.billReminderService.isOpen} onClose={this.billReminderService.close} />;
  }
}

export default observer(BillReminderDialogContainer);
